
// import Vue from 'vue'
// import App from './App.vue'
// import router from './router/index.js'
// import './plugins/element.js'
// import './assets/css/global.css'
// import 'element-ui/lib/theme-chalk/index.css';


// //导入axios
// import axios from 'axios'
// // const axios = require('axios');

// Vue.config.productionTip = false
// axios.defaults.baseURL = 'http://47.120.9.72:8080/'

// //请求拦截器
// // axios.interceptors.request.use(config => {
// //     config.headers.token = window.sessionStorage.getItem('token')
// //     return config
// // })

// // Vue.prototype.$http = axios

// // Vue.config.productionTip = false

// new Vue({
//     router,
//     render: h => h(App)
// }).$mount('#app')

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import './plugins/element.js'
import './assets/css/global.css'
import 'element-ui/lib/theme-chalk/index.css';
import store from '@/store'
//导入axios
import axios from 'axios'
import '@/permission'

//根路径
// axios.defaults.baseURL = 'http://192.168.31.155:8080/'
// axios.defaults.baseURL = 'http://47.120.9.72:8080/'

//请求拦截器
axios.interceptors.request.use(config => {
    config.headers.token = window.sessionStorage.getItem('token')
    return config
})

Vue.use(ElementUI)
Vue.prototype.$http = axios

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')